import HttpService from "./htttp.service";

class EntityCategoriesService {
  getEntityCategories = async (query, cancelToken) => {
    const endpoint = "entity-categories";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createEntityCategory = async (payload) => {
    const endpoint = "entity-categories";
    return await HttpService.post(endpoint, payload);
  };

  removeEntityCategory = async (id) => {
    const endpoint = "entity-categories/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateEntityCategory = async (id, payload) => {
    const endpoint = "entity-categories/" + id;
    return await HttpService.put(endpoint, payload);
  };
}

export default new EntityCategoriesService();
